(function(){
  function init(){
    document.querySelectorAll('[data-kpg-faq]').forEach(function(section){
      var items = section.querySelectorAll('[data-faq-item]');
      items.forEach(function(item){
        var btn = item.querySelector('[data-faq-question]');
        if(!btn || btn.dataset.kpgBound) return;
        btn.dataset.kpgBound = '1';
        btn.addEventListener('click', function(){
          var willOpen = !item.classList.contains('active');
          items.forEach(function(other){
            if(other !== item){
              other.classList.remove('active');
              var ob = other.querySelector('[data-faq-question]');
              if(ob) ob.setAttribute('aria-expanded','false');
            }
          });
          item.classList.toggle('active', willOpen);
          btn.setAttribute('aria-expanded', String(willOpen));
        });
      });
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();